import { useEffect } from "react";
import {
  SettingControllerApiFp,
  SettingParamConfigurationKeyEnum,
  SettingParamValueDataTypeEnum,
  SettingVO,
} from "../../api/generated/v1.0/app";
import { QUERY_KEYS } from "../../constants/queries";
import {
  Settings,
  SETTINGS_DOMAINS,
  SETTINGS_KEYS,
} from "../../constants/settings";
import { INITIAL_SETTINGS } from "../providers/GlobalProvider";
import { useAuth } from "./useAuth";
import { useAxios } from "./useAxios";
import { useGlobalState } from "./useGlobalState";
import { useQueryWithRefresh } from "./useQueryWithRefresh";

export const useGetSettings = () => {
  const axios = useAxios();
  const { auth, setAuth } = useAuth();
  const { globalState, setGlobalState } = useGlobalState();

  const getSettingsRequest = async ({
    axios,
    accessToken,
  }: ProtectedRequest) => {
    return (await SettingControllerApiFp().allUsingGET5(accessToken))(axios);
  };

  const getSettingsQuery = useQueryWithRefresh(
    [QUERY_KEYS.getSettings, auth],
    async () => {
      const res = await getSettingsRequest({
        axios,
        accessToken: auth.accessToken,
      });
      const cleanRes = res.data.map((setting) => {
        if (setting.configurationKey === "import_publication") {
          return {
            ...setting,
            configurationValue: setting.configurationValue === "true",
          };
        }
        return { ...setting };
      });
      return cleanRes;
    }
  );

  useEffect(() => {
    const settings: Settings = Object.assign({}, INITIAL_SETTINGS);
    getSettingsQuery.data?.forEach((item) => {
      const key =
        SETTINGS_KEYS[
          item.configurationKey as SettingParamConfigurationKeyEnum
        ];
      if (
        item.configurationKey &&
        item.configurationValue != undefined &&
        item.lastModifiedAt &&
        key
      ) {
        settings[key] = {
          id: item.id!,
          value: item.configurationValue,
          lastModifiedAt: item.lastModifiedAt,
          valueDataType:
            (item.valueDataType as SettingParamValueDataTypeEnum | undefined) ||
            "string",
          domain: SETTINGS_DOMAINS[key],
        };
      }
    });
    // console.log("fetched new settings");
    // if (settings != globalState.settings) {
    // console.log("New settings");
    // console.log(settings);
    // console.log("SETTINGS ARR:", settings);
    setGlobalState({ settings });
    // }
  }, [getSettingsQuery.data]);
};
